import {
  ACT_INSTANCES_FETCH_CONTEXTS_INIT_ACTION,
  ACT_INSTANCES_FETCH_CONTEXTS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_GET_CONTEXT_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_ADD_CONTEXT_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_DELETE_CONTEXT_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_CONTEXT_FILTERS,
  ACT_INSTANCES_SET_SELECTED_CONTEXT,
} from '../../constants/actions';

export const fetchContextsInitAction = () => ({
  type: ACT_INSTANCES_FETCH_CONTEXTS_INIT_ACTION,
});

export const fetchContextsSuccessAction = data => ({
  type: ACT_INSTANCES_FETCH_CONTEXTS_SUCCESS_ACTION,
  payload: data,
});

export const getContextInitAction = () => ({
  type: ACT_INSTANCES_GET_CONTEXT_INIT_ACTION,
});

export const getContextSuccessAction = data => ({
  type: ACT_INSTANCES_GET_CONTEXT_SUCCESS_ACTION,
  payload: data,
});

export const addContextInitAction = data => ({
  type: ACT_INSTANCES_ADD_CONTEXT_INIT_ACTION,
  payload: data,
});

export const addContextSuccessAction = data => ({
  type: ACT_INSTANCES_ADD_CONTEXT_SUCCESS_ACTION,
  payload: data,
});

export const deleteContextInitAction = id => ({
  type: ACT_INSTANCES_DELETE_CONTEXT_INIT_ACTION,
  payload: id,
});

export const deleteContextSuccessAction = () => ({
  type: ACT_INSTANCES_DELETE_CONTEXT_SUCCESS_ACTION,
});

export const updateContextFiltersAction = filters => ({
  type: ACT_INSTANCES_UPDATE_CONTEXT_FILTERS,
  payload: filters,
});

export const updateSelectedContextAction = component => ({
  type: ACT_INSTANCES_SET_SELECTED_CONTEXT,
  payload: component,
});
